import photo from "../../assets/images/about/profile.webp";
import { Link } from "react-scroll";
import AnimatedElement from "../../components/AnimatedElement/AnimatedElement";
import AnimatedScroll from "../../components/AnimatedScroll/AnimatedScroll";

function Home() {
  document.title = "Dev'Alls - Donnez vie à vos projets d'enfer";

  return (
    <section id="welcome-hero" className="accueil">
      <div className="container">
        <div className="about-content">
          <div className="row rowHome">
            <div className="col-sm-6 textHome">
              {/* 🔥 Encapsule tout le bloc pour éviter le problème de fermeture */}
              <div className="single-about-txt">
                <AnimatedElement delay={0.2}>
                  <h3>Qui sommes nous ?</h3>
                </AnimatedElement>
                <AnimatedElement delay={0.8}>
                  <p className="h3P">
                    Notre agence web crée des sites vitrines, E-Commerce et
                    applications mobiles sur mesure (iOS/Android). Nous
                    accompagnons startups, PME et grandes entreprises à chaque
                    étape, de la conception au développement, avec un suivi
                    personnalisé. Grâce à des technologies modernes, nous
                    offrons des solutions performantes et optimisées pour une
                    expérience utilisateur fluide. Flexible, nous travaillons à
                    distance en France et à l’international, tout en restant
                    proches de nos clients. Faites confiance à notre expertise
                    pour concrétiser vos projets numériques avec efficacité et
                    professionnalisme.
                  </p>
                </AnimatedElement>
              </div>
              <AnimatedElement delay={1.8}>
                <AnimatedScroll>
                  <Link
                    className="btn_services"
                    to="about"
                    href="#about"
                    smooth={true}
                    duration={1000}
                  >
                    Découvrez plus{" "}
                  </Link>
                </AnimatedScroll>
              </AnimatedElement>
            </div>

            <AnimatedElement delay={2}>
              <AnimatedScroll offset={200}>
                <div className="col-sm-offset-1 col-sm-5 homeImg">
                  <div className="single-about-img">
                    <img src={photo} alt="profile_image" />

                    <div className="about-list-icon">
                      <ul>
                        <li>
                          <a
                            aria-label="Facebook"
                            href="https://www.facebook.com/profile.php?id=61571974268200"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i
                              className="fa fa-facebook"
                              aria-hidden="true"
                            ></i>
                          </a>
                        </li>
                        <li>
                          <a
                            aria-label="LinkedIn"
                            href="https://www.linkedin.com/company/106179908/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i
                              className="fa fa-linkedin"
                              aria-hidden="true"
                            ></i>
                          </a>
                        </li>
                        <li>
                          <a
                            aria-label="Instagram"
                            href="https://www.instagram.com/dev.alls/?igsh=amlmamgwa3djMjVs"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i
                              className="fa fa-instagram"
                              aria-hidden="true"
                            ></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </AnimatedScroll>
            </AnimatedElement>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Home;
